import React, { useEffect, useRef } from 'react';
import './Hero.css';

export default function Hero() {
  const titleRef = useRef(null);

  useEffect(() => {
    const letters = titleRef.current?.querySelectorAll('.char');
    letters?.forEach((el, i) => {
      el.style.animationDelay = `${0.05 * i + 0.3}s`;
    });
  }, []);

  const name = "Nikhil Vinchurkar";

  return (
    <section className="hero" id="hero">
      <div className="hero-bg">
        <div className="hero-blob blob1" />
        <div className="hero-blob blob2" />
        <div className="grid-lines" />
      </div>
      <div className="hero-content">
        <div className="hero-badge">Available for work</div>
        <h1 className="hero-title" ref={titleRef}>
          {name.split('').map((ch, i) =>
            ch === ' '
              ? <span key={i} className="char space"> </span>
              : <span key={i} className="char">{ch}</span>
          )}
        </h1>
        <p className="hero-role">Full Stack Java Developer</p>
        <p className="hero-desc">
          Building scalable web applications with Java, Spring Boot & React.js. Passionate about clean architecture, performance, and impactful user experiences.
        </p>
        <div className="hero-actions">
          <button className="btn-primary" onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}>
            View Projects <span>→</span>
          </button>
          <button className="btn-ghost" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
            Get in touch
          </button>
        </div>
        <div className="hero-stats">
          <div className="stat"><span className="stat-num">2+</span><span className="stat-label">Years Learning</span></div>
          <div className="stat-divider" />
          <div className="stat"><span className="stat-num">3</span><span className="stat-label">Internships</span></div>
          <div className="stat-divider" />
          <div className="stat"><span className="stat-num">5+</span><span className="stat-label">Technologies</span></div>
        </div>
      </div>
      <div className="hero-scroll">
        <span>scroll</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
}
